var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositionAufrecht(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204.91 208.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 131.04,
    width: 0.43,
    height: 74.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 131.04,
    width: 0.43,
    height: 74.5,
    transform: "translate(-107.33 77.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 168.07,
    width: 74.5,
    height: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 168.07,
    width: 74.5,
    height: 0.43,
    transform: "translate(-107.38 77.56) rotate(-45.04)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 168.07,
    width: 74.5,
    height: 0.43,
    transform: "translate(-130.77 140.03) rotate(-67.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 131.04,
    width: 0.43,
    height: 74.5,
    transform: "translate(-60.75 27.61) rotate(-22.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 131.04,
    width: 0.43,
    height: 74.5,
    transform: "translate(-130.76 139.95) rotate(-67.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 168.07,
    width: 74.5,
    height: 0.43,
    transform: "translate(-60.79 27.64) rotate(-22.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 168.07,
    width: 74.5,
    height: 0.43,
    transform: "translate(-132.93 175.92) rotate(-79.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 131.04,
    width: 0.43,
    height: 74.5,
    transform: "translate(-87.61 51.4) rotate(-34.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 131.03,
    width: 0.43,
    height: 74.5,
    transform: "translate(-132.93 175.75) rotate(-79.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 168.07,
    width: 74.5,
    height: 0.43,
    transform: "translate(-87.56 51.34) rotate(-34.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 168.07,
    width: 74.5,
    height: 0.43,
    transform: "translate(-122.4 108.41) rotate(-56.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 131.04,
    width: 0.43,
    height: 74.5,
    transform: "translate(-32.48 11.2) rotate(-11.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 131.04,
    width: 0.43,
    height: 74.5,
    transform: "translate(-122.38 108.35) rotate(-56.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 168.07,
    width: 74.5,
    height: 0.43,
    transform: "translate(-32.51 11.21) rotate(-11.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.84,205.83a37.55,37.55,0,1,1,37.55-37.54A37.58,37.58,0,0,1,39.84,205.83Zm0-70.2A32.66,32.66,0,1,0,72.5,168.29,32.69,32.69,0,0,0,39.84,135.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.88,168.29a4,4,0,1,1-4-4A4,4,0,0,1,43.88,168.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.84,208.13a39.85,39.85,0,1,1,39.85-39.84A39.88,39.88,0,0,1,39.84,208.13Zm0-74.5A34.66,34.66,0,1,0,74.5,168.29,34.69,34.69,0,0,0,39.84,133.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 57.59,
    y: 117.98,
    width: 71.74,
    height: 3.81
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "112.81 169.12 54.62 126.95 56.47 123.61 114.66 165.78 112.81 169.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.36,98.82a8,8,0,1,0,0,15.9,2.14,2.14,0,0,0,0-4.28h0a3.67,3.67,0,0,1,0-7.34v0H60.73l-22.3,65.38,3.47,1.18,23-66.56a3.15,3.15,0,0,0-.86-3.16,4.48,4.48,0,0,0-2.88-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.2,98.82H45.36a8,8,0,1,0,0,15.9,2.14,2.14,0,0,0,0-4.28h0a3.67,3.67,0,0,1,0-7.34v0H60.73L56.2,116.35h4.15l4.59-13.27a3.15,3.15,0,0,0-.86-3.16A4.48,4.48,0,0,0,61.2,98.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.36,114.72a2.14,2.14,0,0,0,0-4.28h0a3.67,3.67,0,0,1,0-7.34v0h5.87V98.82H45.36a8,8,0,1,0,0,15.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.14,92.46a1,1,0,0,0,.12-1.29c-.4-.87-1.45-2.62-4.81-2.5s-8.18,1-11.67.67-8.43-.29-10.8.36-3.06,1.9-2,2.33,4.16.54,7.67.63a23.13,23.13,0,0,1,7.42,1.39c1.79.58,2.09,1,3.63.81s3.8-1.65,5.83-2S147,92.72,147.14,92.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "111.08 169.05 114.55 170.23 139.34 90.85 135.13 90.85 111.08 169.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "115.89 178.86 115.78 178 164.8 171.46 164.91 172.32 115.89 178.86"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139.15,
    y: 136.23,
    width: 1.3,
    height: 49.95,
    transform: "translate(-43.59 270.3) rotate(-79.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.82,164.45s-3.69,2.11-6.41,1.22a4.07,4.07,0,0,0-1.87-1.84h0c-.91-2.72,1.21-6.43,1.21-6.43l-3-.78h0l-3,.78s2.12,3.71,1.22,6.43h0a4,4,0,0,0-1.87,1.84c-2.72.89-6.41-1.22-6.41-1.22l-.77,3h0l.77,2.95s3.64-2.07,6.35-1.23a4.06,4.06,0,0,0,1.94,2c.82,2.71-1.24,6.32-1.24,6.32l3,.78h0l3-.78s-2.06-3.61-1.24-6.32a4,4,0,0,0,1.94-2c2.72-.84,6.36,1.23,6.36,1.23l.77-2.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.81,179.26a11.81,11.81,0,1,1,11.81-11.81A11.83,11.83,0,0,1,112.81,179.26Zm0-21.89a10.09,10.09,0,1,0,10.09,10.08A10.09,10.09,0,0,0,112.81,157.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M110.91,167.29a3.72,3.72,0,0,1-1.67,1,33.85,33.85,0,0,0-6.61,2.42c-2.27,1.21-6.3,3.25-6.3,3.25l-.78,3s2.66-1.2,3.9-1.56a57.78,57.78,0,0,0,7.23-2.85c2.1-1.06,3.94-2.25,4.64-2.34a6.49,6.49,0,0,0,1.69-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M97.57,175.5a2,2,0,0,1-2,2H90.47a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h5.06a2,2,0,0,1,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M94.46,175.51A1.46,1.46,0,1,1,93,174.05,1.46,1.46,0,0,1,94.46,175.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115,167.45a2.21,2.21,0,1,1-2.21-2.21A2.21,2.21,0,0,1,115,167.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 131.04,
    width: 0.43,
    height: 74.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 131.04,
    width: 0.43,
    height: 74.5,
    transform: "translate(-70.65 166.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 168.07,
    width: 74.5,
    height: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 168.07,
    width: 74.5,
    height: 0.43,
    transform: "translate(-70.65 166.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 168.07,
    width: 74.5,
    height: 0.43,
    transform: "translate(-53.95 255.46) rotate(-67.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 131.04,
    width: 0.43,
    height: 74.5,
    transform: "translate(-51.43 75.03) rotate(-22.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 131.04,
    width: 0.43,
    height: 74.5,
    transform: "translate(-53.96 255.43) rotate(-67.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 168.07,
    width: 74.5,
    height: 0.43,
    transform: "translate(-51.46 75.11) rotate(-22.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 168.07,
    width: 74.5,
    height: 0.43,
    transform: "translate(-31.17 298.9) rotate(-79.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 131.04,
    width: 0.43,
    height: 74.5,
    transform: "translate(-66.01 121.7) rotate(-34.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 131.03,
    width: 0.43,
    height: 74.5,
    transform: "translate(-31.27 298.74) rotate(-79.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 168.07,
    width: 74.5,
    height: 0.43,
    transform: "translate(-65.99 121.58) rotate(-34.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 168.07,
    width: 74.5,
    height: 0.43,
    transform: "translate(-66.43 212.74) rotate(-56.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 131.04,
    width: 0.43,
    height: 74.5,
    transform: "matrix(0.98, -0.2, 0.2, 0.98, -30.01, 35.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 131.04,
    width: 0.43,
    height: 74.5,
    transform: "translate(-66.45 212.66) rotate(-56.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 168.07,
    width: 74.5,
    height: 0.43,
    transform: "translate(-29.91 35.81) rotate(-11.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.07,205.83a37.55,37.55,0,1,1,37.54-37.54A37.58,37.58,0,0,1,165.07,205.83Zm0-70.2a32.66,32.66,0,1,0,32.66,32.66A32.7,32.7,0,0,0,165.07,135.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.1,168.29a4,4,0,1,1-4-4A4,4,0,0,1,169.1,168.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165.07,208.13a39.85,39.85,0,1,1,39.84-39.84A39.88,39.88,0,0,1,165.07,208.13Zm0-74.5a34.66,34.66,0,1,0,34.66,34.66A34.7,34.7,0,0,0,165.07,133.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.19,165.83l-36.06-46.27-2.74,2.65,35.07,45a2.61,2.61,0,1,0,3.73-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M132.19,47.11c2.13,1.33,3,3.43,4.89,5,2.54,2.06,2.43,4.06,4.59,6.51s.13,6,2,8.62c1.41,1.94-2,.45-.65,2.41A14.83,14.83,0,0,1,145.2,83.5c-.68,2.11-1.33,3.71-3.28,5.17-6.29,4.67-8.42,11.82-13.7,17.75-2.35,2.64-5.34,4.17-8.23,6a69.21,69.21,0,0,0-7.15,5.56,20.83,20.83,0,0,0-2.33,2.83c1.28,1.06,2.8,2.17,4.13,3.47,2.92,2.85,6.1,5.54,8.45,8.82,1.14,1.58,1.86,3.6,3.38,5,1.08,1,2.43,1.69,3.48,2.71,1.67,1.61,3.18,3.39,4.79,5.07a5.59,5.59,0,0,0,1.5,1.16c3.27,1.52,4.73,4.84,7.16,7.2,1.15,1.11,2.35,2.79,1.49,4.61a6.63,6.63,0,0,1-5.07,3.85,5.52,5.52,0,0,0-2.25.84c-2.56,1.84-4.94,4-7.6,5.63a13.23,13.23,0,0,1-5.9,2.3c-1.25.07-2.71-1.58-3.83-2.71-.28-.29.21-1.61.62-2.28,1.52-2.53,3.14-5,4.76-7.45a4.68,4.68,0,0,0-.15-5.62,50.48,50.48,0,0,1-3.34-5.51,13.55,13.55,0,0,0-5-5.09l-13-8.38a7.23,7.23,0,0,0-.29,1.71c.14,3.16.29,6.32.56,9.46.37,4.27.72,8.54,1.33,12.77.25,1.78,1,3.48,3.26,3.9,1.44.27,1.56,1.58,1.47,2.72a24.36,24.36,0,0,1-.76,4.49,2.5,2.5,0,0,1-1.42,1.3,44.68,44.68,0,0,1-4.89,1.54,25.64,25.64,0,0,0-9.54,4.07,8.86,8.86,0,0,1-8.16,1.34c-2.63-.87-5-2.67-7.33-4.25-.44-.3-.47-1.53-.33-2.26.06-.36,1-.84,1.46-.79,2.62.26,4.61-1,6.44-2.56a44.13,44.13,0,0,0,6.23-5.9c1-1.32,1-3.43,1.52-5.17a4.72,4.72,0,0,1,.73-1.11c.18-.28.53-.58.51-.85-.13-1.8-.34-3.61-.54-5.41,0-.18-.19-.36-.18-.53.26-4.73-2-8.86-3.11-13.27-.88-3.62-1.59-7.28-2.21-11a23.84,23.84,0,0,0-3.36-9.49c-1.29-1.94-.61-7.28,1.08-8.83,2.18-2,4.23-4.14,6.39-6.15a27,27,0,0,1,2.71-2c.4-.3.81-.59,1.18-.93,4.24-3.85,8.47-7.73,12.73-11.56a9.12,9.12,0,0,1,2.09-1.29c1.91-1,3-2.1,2.31-4.56-.42-1.45,1.62-3,.2-2.87-1.72.12-2.42-2.06-3.6-3.64-.59-.79-4.81-4.3-5.49-5.23a15,15,0,0,1-1.68-2.62c-.69-1.42-5.14-7.82-6.51-7.53-1.8.36-2.18,7.56-3.46,11.17-1.65,2.36-1.95,1.43-2.35,2.93-1.73,4.28-2.36,3.13-5.42,7.41-4.58,3.9-10.62,9.84-15.39,13.34-5.19,3.81-9.91,5.58-15,9.55-1.76,1.37-4,2.13-6.06,3.09a1.44,1.44,0,0,1-1.21-.31c-1.93-1.56-3.87-3.12-5.67-4.82-.38-.36-.34-1.3-.28-2,.16-1.76,2.26.36,2.41-1.4,0-.51,1.21.76.88.58-.68-.38-.39.92-1.19.73-.47-.79-.46-.5,0,0,1.56,1.68-.4-1.27,0,0-1.53,1.6,2.92-1.51,1-.22,1.23-2.62-.2,1.12,0,0-.18-1.91.15,1.91,0,0,.91,1.92.06,1.43,0,0-.09-2-1.65-1.27.23-.51a10.51,10.51,0,0,1-2.94.24c2.07-1.24,5.17-2.2,6.2-3a3,3,0,0,1,2.47-.86c1.86.17,3.37-1.8,5.18-2.12,2.84-2.43,1.74-1.71,2.31-2.27,4-4,7.91-6,9.8-7.81a48,48,0,0,0,3.51-5.55c1.57-2.6.39.23,1.57-2.6a7.88,7.88,0,0,1,1-1.11c2.61-3.07,7.08-10.14,8.23-13.59A88.32,88.32,0,0,1,83.9,47.5c.48-1.66.75-8.55-.87-9a68.39,68.39,0,0,1-6.73-2c-1.15-.45-1.87-1.63-3.5-1.2C69,36.3,69,36.18,67,32.68c-.66-1.16-1.46-2.24-2.17-3.32-2.52.15-2.6-.08-2.57-2.45a20.88,20.88,0,0,0-.84-6.12,1.6,1.6,0,0,0-.77-.77c-.65-.34-1.76-.43-1.93-.9a6.93,6.93,0,0,1-.3-3.32,46.52,46.52,0,0,1,1.44-5.51c1-3.13,3.33-4.53,6.24-5.84C70.93,2.3,76,1.21,81,0a1.85,1.85,0,0,1,.71.13L82,.69a12.43,12.43,0,0,1-2.31,1.15c-2.76.71-5.57,1.22-8.32,2A23.71,23.71,0,0,0,67,5.61a2.15,2.15,0,0,0-.9,1.75L67.23,7l6.11-1.81,3.78-1.16c.42-.13,1-.47,1.26-.32,2.14,1.2,3-.59,4.13-1.73a2.85,2.85,0,0,1-.41,4C80,7.75,78,9.63,75.91,11.46h0l-1,1.62c.5.2.9-.18,1.32-.44,1.09-.67.56-2,2.7-2.06-.27-1.07,3.41,1.18,3.21.41l-3.61-.46c1.55-1.26,2.71-2.15,3.82-3.12.61-.54,1.09-1.22,1.67-1.79A1.49,1.49,0,0,1,85,5.19a.88.88,0,0,1,.59.62c.18,2,.18,4,.49,6,.25,1.6.9,3.14,1.31,4.73a24,24,0,0,1,1.07,4.88c.1,2.09,1,3.38,3.15,3.35,1.89,0,3.78-.31,5.68-.34,4.77,2.18,4.17,3.61,8.91,4.9,2.71,1.15,6.56,4.91,9.6,7,4.57,3.07-.24-.09,0,0M63.14,14.69l.51.44a55.12,55.12,0,0,1,3.82-4.51A53,53,0,0,1,72,7.05C68.1,8.55,64.87,10.8,63.14,14.69Zm72.29,132.59-.42.58,3.79,2.52.35-.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "112.81 164.09 116.29 165.27 135.25 102.92 130.41 105.02 112.81 164.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.85,205.61a37.55,37.55,0,1,1,37.55-37.54A37.58,37.58,0,0,1,164.85,205.61Zm0-70.2a32.66,32.66,0,1,0,32.66,32.66A32.7,32.7,0,0,0,164.85,135.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.85,207.91a39.84,39.84,0,1,1,39.85-39.84A39.88,39.88,0,0,1,164.85,207.91Zm0-74.5a34.66,34.66,0,1,0,34.66,34.66A34.69,34.69,0,0,0,164.85,133.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.15,165.83l-36.06-46.27-2.74,2.65,35.07,45a2.61,2.61,0,1,0,3.73-1.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "126.36 121.79 102.04 121.79 104.8 117.98 126.36 117.98 126.36 121.79"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionAufrecht);
export default __webpack_public_path__ + "static/media/position-aufrecht.8e0576319f6e807b03375d065af9fe04.svg";
export { ForwardRef as ReactComponent };